'use client';

import { Box, Grid, Typography } from "@mui/material";
import { useTranslations } from "next-intl";

const StartUpSupport = () => {
    const t = useTranslations("ServicePage.startup_support");
    return (
        <Box sx={{ py: { xs: 8, md: 12 }, px: 2, backgroundColor: "#f8fafc" }}>
            <Box sx={{
                maxWidth: "lg",
                margin: "auto",
            }}>
                <Box sx={{ textAlign: "center", mb: 8 }}>
                    <Typography variant="h4" component="h2" sx={{ fontWeight: 800, color: "#132c4b", mb: 2 }}>
                        {t('title')}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#64748b" }}>
                        {t('description')}
                    </Typography>
                </Box>

                <Grid container spacing={4}>
                    {/* Plan 1 */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{
                            height: "100%",
                            border: "1px solid #e2e8f0",
                            borderRadius: "24px",
                            p: { xs: 2, md: 4 },
                            backgroundColor: "white"
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2, textAlign: "left" }}>
                                {t('plan_1_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: "bold", color: "#334155", mb: 2 }}>
                                {t('plan_1_desc')}
                            </Typography>
                            <Box component="ul" sx={{ pl: 2, m: 0, color: "#64748b", fontSize: "0.875rem" }}>
                                <li>{t('plan_1_item_1')}</li>
                                <li>{t('plan_1_item_2')}</li>
                                <li>{t('plan_1_item_3')}</li>
                                <li>{t('plan_1_item_4')}</li>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Plan 2 */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{
                            height: "100%",
                            border: "1px solid #e2e8f0",
                            borderRadius: "24px",
                            p: { xs: 2, md: 4 },
                            backgroundColor: "white"
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2, textAlign: "left" }}>
                                {t('plan_2_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: "bold", color: "#334155", mb: 2 }}>
                                {t('plan_2_desc')}
                            </Typography>
                            <Box component="ul" sx={{ pl: 2, m: 0, color: "#64748b", fontSize: "0.875rem" }}>
                                <li>{t('plan_2_item_1')}</li>
                                <li>{t('plan_2_item_2')}</li>
                                <li>{t('plan_2_item_3')}</li>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Plan 3 */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{
                            height: "100%",
                            border: "1px solid #e2e8f0",
                            borderRadius: "24px",
                            p: { xs: 2, md: 4 },
                            backgroundColor: "white"
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2, textAlign: "left" }}>
                                {t('plan_3_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: "bold", color: "#334155", mb: 2 }}>
                                {t('plan_3_desc')}
                            </Typography>
                            <Box component="ul" sx={{ pl: 2, m: 0, color: "#64748b", fontSize: "0.875rem" }}>
                                <li>{t('plan_3_item_1')}</li>
                                <li>{t('plan_3_item_2')}</li>
                                <li>{t('plan_3_item_3')}</li>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Plan 4 */}
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{
                            height: "100%",
                            border: "1px solid #e2e8f0",
                            borderRadius: "24px",
                            p: { xs: 2, md: 4 },
                            backgroundColor: "white"
                        }}>
                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#1e293b", mb: 2, textAlign: "left" }}>
                                {t('plan_4_title')}
                            </Typography>
                            <Typography variant="body2" sx={{ fontWeight: "bold", color: "#334155", mb: 2 }}>
                                {t('plan_4_desc')}
                            </Typography>
                            <Box component="ul" sx={{ pl: 2, m: 0, color: "#64748b", fontSize: "0.875rem" }}>
                                <li>{t('plan_4_item_1')}</li>
                                <li>{t('plan_4_item_2')}</li>
                                <li>{t('plan_4_item_3')}</li>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default StartUpSupport;
